module.exports = __webpack_public_path__ + "9786599366dedae2725c830f02a1ddf4.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/default/variant-naming/images-more-on-naming/img2.png
// module id = 1305
// module chunks = 0